import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserDetails } from '../../../zustand';
import { UserIcon } from '../../../helpers/icons';

const PendingCustomersIcon = () => {
  const navigate = useNavigate();
  const { pending_customer = null } = useUserDetails(
    (s) => s.userDetails || {},
  );

  return (
    <div
      className="position--relative c--pointer"
      data-tooltip="Pending Customers"
      tooltip-position="left"
    >
      <span
        className="text--primary bg--primary-50 p--sm radius--full w-min--36 w-max--36 h-min--36 h-max--36 d--flex align-items--center justify-content--center"
        onClick={() => navigate('/pending-customers')}
      >
        <UserIcon width={20} height={20} />
      </span>
      {Boolean(parseInt(pending_customer)) ? (
        <div className="count-badge position--absolute top--0 right---5 font--xs font--600 bg--danger text--white">
          {pending_customer}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default PendingCustomersIcon;
